import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/services/user.service';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { UserAuthService } from '../shared/services/auth/user-auth.service';
import { CommonHttpClient } from '../shared/services/common/common-http.service';
declare function viewPassword(): any;
declare function viewCPassword(): any;
declare function viewCCPassword(): any;

@Component({
  selector: 'ngbd-modal-content',
  template: `
		<div class="modal-header">
			<h4 style="color:black!important;" class="modal-title">Profile update</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
		</div>
		<div class="modal-body">
			<h5 style="color:black!important;">Your email address and password have been successfully updated.</h5>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-blue submitBtn" (click)="activeModal.close('Close click')">OK</button>
		</div>
	`,
})
export class NgbdModalContent {
  constructor(public activeModal: NgbActiveModal) { }
}

@Component({
  selector: 'app-change-email-link',
  templateUrl: './change-email-link.component.html',
  styleUrls: ['./change-email-link.component.css'],
  animations: [
    trigger(
      'slideView',
      [
        state('true', style({ transform: 'translateX(100%)', opacity: 0 })),
        state('false', style({ transform: 'translateX(0)', opacity: 1 })),
        transition('0 => 1', animate('500ms', style({ transform: 'translateX(0)', 'opacity': 1 }))),
        transition('1 => 1', animate('500ms', style({ transform: 'translateX(100%)', 'opacity': 0 }))),
      ]),

    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)', 'opacity': 1 }))
      ]),

      transition(':leave', [
        style({ transform: 'translateX(0%)', opacity: 1 }),
        animate('0ms ease-in', style({ transform: 'translateX(100%)', 'opacity': 0 }))
      ])
    ])
  ]
})
export class ChangeEmailLinkComponent implements OnInit {
  
  //get from html forms

  password: string;
  newEmail: string;
  error: string;
  EmailChanged: boolean = false;
  changeEmailForm: FormGroup;
  submit: boolean = false;
  passwordNotMatchError: string;
  closeResult = '';
  
  success: any;
  changePhoneByPhoneCheck: boolean;
  response: any;
  apiCalled: boolean;
  param: any;
    email: any;
    phone: any;
    userId: any;
    PasswordChanged: boolean;
  constructor(private userService: UserService, private _location: Location, private router: Router, private ngxloader: NgxUiLoaderService,
    private modalService: NgbModal, private userAuth: UserAuthService, route: ActivatedRoute, private commonHttpInit: CommonHttpClient) {
    this.initChangePasswordForm();
    this.param = route.snapshot.params.param;
    this.initCommonHTTP();
  }

  ngOnInit(): void {
  }
  async initCommonHTTP()
  {
    this.ngxloader.start();
    var key = await this.commonHttpInit.getApiKey()
      if(key){
        this.getSubscriptionDetails();
      }   
  }
  changeEmail() {
    this.ngxloader.start();
    this.password = this.changeEmailForm.get("password").value;
    this.newEmail = this.changeEmailForm.get("new_email").value;
    if (this.param.includes("@")) {
      this.email = this.param;
    }
    else {
      this.phone = this.param
    }
    if (this.param != null) {
      if (this.param.includes("@")) {
        var famData = {
          new_email: this.newEmail
        }
        this.userService.changeEmailByEmailFromLink(this.email, this.newEmail, this.password).subscribe(resp => {
          if (resp.message === 'Email changed!') {
            this.userService.changeEmailMariaAPIByEmail(this.email, famData).subscribe(famResp => {
              if (famResp.message === 'Email changed successfully!') {
                this.ngxloader.stop();
                this.EmailChanged = true;
                //success pop up
                this.userService.changePasswordFromlink(this.password, this.userId, '+' + this.phone).subscribe(famResp => {
                  if (famResp.message === 'Password changed successfully!') {
                    this.ngxloader.stop();
                    this.PasswordChanged = true;
                    //success pop up
                    this.open();
                  }
                });
              } else {
                this.error = famResp.message;
                this.ngxloader.stop();
              }

            });

          } else {
            this.error = resp.message;
            this.ngxloader.stop();
          }
        }, error => { this.error = 'Error changing email!' })
      }

      if (!this.param.includes("@")) {
        var phone = this.param;
        var famData = {
          new_email: this.newEmail
        }
        this.userService.changeEmailByPhoneFromLink(phone,this.newEmail,this.password).subscribe(resp => {
          if (resp.message === 'Email changed!') {
            this.userService.changeEmailMariaAPIByPhone(phone, famData).subscribe(famResp => {
              if (famResp.message === 'Email changed successfully!') {
                this.ngxloader.stop();
                this.EmailChanged = true;
                //success pop up
                this.userService.changePasswordFromlink(this.password, this.userId, '+' + this.phone).subscribe(famResp => {
                  if (famResp.message === 'Password changed successfully!') {
                    this.ngxloader.stop();
                    this.PasswordChanged = true;
                    //success pop up
                    this.open();
                  }
                });

              } else {
                this.error = famResp.message;
                this.ngxloader.stop();
              }

            });
          } else {
            this.error = resp.message;
            this.ngxloader.stop();
          }
        }, error => { this.error = 'Error changing email!' })

      }
    }
    else {
      this.error = 'Error changing email!'
    }
  }
  get f() {
    return this.changeEmailForm.controls;
  }

  initChangePasswordForm() {
    this.changeEmailForm = new FormGroup({
      new_email: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/), Validators.maxLength(254)]),
      password: new FormControl('', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&~`#^()_={}|:;"'<,>.])[A-Za-z\d@$!%*?&~`#^()_={}|:;"'<,>.]{8,}$/)]),
      confirm_new_password: new FormControl('', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&~`#^()_={}|:;"'<,>.])[A-Za-z\d@$!%*?&~`#^()_={}|:;"'<,>.]{8,}$/)]),
    }, { validators: this.passwordMatchingValidatior });
  }
  backClicked() {
    if (this.router.navigated) {
      this._location.back();
    }

  }

  clearPasswordNotMatchError() {
    this.passwordNotMatchError = null;
  }

  passwordMatchingValidatior: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const newEmail = control.get('new_email');
    const newPassword = control.get('password');
    const confirm_new_password = control.get('confirm_new_password');

    if (newPassword.value != '' && newPassword.value != null) {
      var patternPass = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&~`#^()_={}|:;"'<,>.])[A-Za-z\d@$!%*?&~`#^()_={}|:;"'<,>.]{8,}$/);
      let newCurrentPassword = newPassword.value;
      var resultPass = newCurrentPassword.match(patternPass);
    }
    
    if (newPassword.value != confirm_new_password.value && newPassword.value != null && confirm_new_password.value != null && newPassword.value != '' && confirm_new_password.value != '' &&
      confirm_new_password.value != newPassword) {
      this.passwordNotMatchError = "New Password does not match the Confirm New Password!"
      this.changeEmailForm.invalid;
    }
    else {
      this.clearPasswordNotMatchError();
    }
    if (confirm_new_password.value === newPassword.value && confirm_new_password.value != null && newPassword.value != null && confirm_new_password.value != '' && newPassword.value != '') {
      if (!resultPass) {
        this.passwordNotMatchError = "Password must be at least eight characters, with one uppercase letter, one lowercase letter, one number and one special character."
      } else {
        this.clearPasswordNotMatchError();
      }
    }
    if (newEmail.value != '' && newEmail.value != null) {
      var pattern = new RegExp(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/);
      let currentEmail = newEmail.value;
      var result = currentEmail.match(pattern);
    }

    if (newEmail.value != null && newEmail.value != '') {
      if (!result) {
        this.passwordNotMatchError = "Please enter a valid email address."
      } else {
        if (resultPass) {
        this.clearPasswordNotMatchError();
        }
      }
    }
    return newEmail?.value ? null : { notmatched: true };
  };

  open() {
    const modalRef = this.modalService.open(NgbdModalContent).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
        this.router.navigate(['/login'])
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.router.navigate(['/login'])
      },
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  clearInfoMessages() {
    this.error = null;
    this.success = null;
  }

  removePlusFromstring(phoneNumber) {
    return phoneNumber.split('+').join('')
  }

  verifyUserSubscription() {
    this.clearInfoMessages();
    let email = this.changeEmailForm.get('new_email').value;
    if (email) {
      let data = {
        email_id: email
      }
      this.userService.validateUserEmailAddress(data).subscribe(resp => {
        this.ngxloader.start();
        if (resp.message === 'success (email already exists)') {
          this.response = resp.message;
          this.error = "This email is already registered";
          this.ngxloader.stop();
        } else {
          this.changeEmail();
        }
      }, err => {
        this.ngxloader.start();
        this.changeEmail();
      });
    }
  }

  getSubscriptionDetails() {
    if (this.param.includes("@")) {
      this.email = this.param;
    }
    else {
      this.phone = this.param
    }
    this.ngxloader.start();
    if (this.param.includes("@")) {
      this.userService.getIdMariaAPIByEmail(this.email).subscribe(resp => {
        if (resp != null) {
          this.userId = resp[0].id
          this.userService.getSubscriptionDetailsWithEmailFromLink(this.email).subscribe(resp => {
            if (resp.message == 'success') {
              this.phone = resp.phone_number;
            }
            this.apiCalled = true;
            this.ngxloader.stop();
          }, error => {
            this.apiCalled = true;
            this.ngxloader.stop();
          })
        }
        this.apiCalled = true;
        this.ngxloader.stop();
      }, error => {
        this.apiCalled = true;
        this.ngxloader.stop();
      })
    } else {
      this.userService.getIdMariaAPIByPhone(this.phone).subscribe(resp => {

        if (resp != null) {
          this.userId = resp[0].id
        }
        this.apiCalled = true;
        this.ngxloader.stop();
      }, error => {
        this.apiCalled = true;
        this.ngxloader.stop();
      })
    }

  }
}
